export const id = {
  msg:
    {
      'username': 'Nama Pengguna',
      'password': 'Kata Sandi',
      'login': 'Masuk',
      'username_not_found': 'Masukkan nama pengguna anda.',
      'password_not_found': '54. Masukkan kata sandi anda',
      'error': 'Nama pengguna atau kata sandi tidak valid',
      'changeLanguage': '',
      'lang-en': 'English',
      'lang-ms': 'Bahasa Melayu',
      'submit_button_text': 'Submit',
      'enter': 'Masuk',
      'en': 'English',
      'ms': 'Bahasa Melayu',
      'zh': 'Chinese',
      'ta': 'Tamil',
      'km': 'Khmer',
      'th': 'Thai',
      'id': 'Bahasa Indonesia',
      'ar': 'Arabic',
      'blank_username_field': 'Masukkan nama pengguna anda.',
      'blank_password_field': 'Masukkan kata sandi anda',
      'invalid_credentials': 'Nama pengguna atau kata sandi tidak valid',
      'copyright': 'Didukung oleh Global Psytech'
    }
}
